export const TOPIC_FIELD_NAME = "name";
export const CATEGORY_FIELD_NAME = "category";
export const DOMAINS_COUNT_FIELD_NAME = "domainsCount";

export const DEFAULT_SORT_DIRECTION = "asc";

export const DEFAULT_LOCKED_PERIOD = 90;
